export default {
      id: "weather__cloudy-2-usage",
      viewBox: "0 0 64 64",
      url: __webpack_public_path__ + "img/icons.svg#weather__cloudy-2",
      toString: function () {
        return this.url;
      }
    }